"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var NewInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(NewInit, _super);
    function NewInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的页面初始化接口（改版）';
        _this.code = '101156';
        _this.desc = '我的页面初始化接口（改版）';
        _this.requestParams = new myPage_1.NewInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return NewInit;
}(service_1.BaseService));
exports.NewInit = NewInit;
//# sourceMappingURL=newInit.js.map